import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class BursTuruListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "BursTuruListe";
    super(baseUrl);
  }


  getBursTuruListe( bursTuruKodu?: number){
    return this.get("", {params:{ bursTuruKodu: bursTuruKodu}});

  }

}


export default new BursTuruListeAPI();
class BursTuruListeRequest {
  public bursTuruKodu?: number;

 
  constructor(bursTuruKodu?: number) {
   
      this.bursTuruKodu = bursTuruKodu;

      
  }
}
export { BursTuruListeRequest };